import { useRef, useEffect } from 'react';

export const useMouseGlow = () => {
  const elementRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    if (!elementRef.current || !glowRef.current) return;

    const handleMouseMove = (e) => {
      const element = elementRef.current;
      const glow = glowRef.current;
      
      // Get element's bounding rectangle
      const rect = element.getBoundingClientRect();
      
      // Calculate mouse position relative to element
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Calculate distance from center
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const distance = Math.sqrt(
        Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)
      );
      
      // Maximum distance (diagonal from center to corner)
      const maxDistance = Math.sqrt(
        Math.pow(centerX, 2) + Math.pow(centerY, 2)
      );
      
      // Calculate intensity (closer to cursor = higher intensity)
      const intensity = Math.max(0, 1 - distance / maxDistance);
      
      // Update glow position and intensity
      glow.style.left = `${x}px`;
      glow.style.top = `${y}px`;
      glow.style.opacity = Math.pow(intensity, 0.5) * 0.8;
      glow.style.boxShadow = `0 0 ${40 + intensity * 60}px ${10 + intensity * 30}px rgba(74, 144, 226, ${0.6 + intensity * 0.4})`;
    };

    const handleMouseLeave = () => {
      const glow = glowRef.current;
      glow.style.opacity = '0';
    };

    const handleMouseEnter = () => {
      const glow = glowRef.current;
      glow.style.opacity = '0.4';
    };

    elementRef.current.addEventListener('mousemove', handleMouseMove);
    elementRef.current.addEventListener('mouseleave', handleMouseLeave);
    elementRef.current.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      if (elementRef.current) {
        elementRef.current.removeEventListener('mousemove', handleMouseMove);
        elementRef.current.removeEventListener('mouseleave', handleMouseLeave);
        elementRef.current.removeEventListener('mouseenter', handleMouseEnter);
      }
    };
  }, []);

  return { elementRef, glowRef };
};
